module.exports = __webpack_public_path__ + "static/media/icon-chevron-right-circle.b317af1c.svg";